pageId = 'teams-dashboards-overdue_todos-show'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-dashboard').addClass 'active'

  tower.adjustTodo()

  tower.scrollLoad $page, ->
    currentType = $('.dashboard-project:last').data 'type'
    $.ajax
      url: location.href
      dataType: 'html'
      type: 'get'
      data:
        till_todo_guid: $('.todo:last').data 'guid'
        type: currentType
      success: (result) ->
        return unless result
        $result = $(result)
        if $result.data('type') == currentType
          $todos = $($result.find('.todolist__todos').html())
          tower.adjustTodo $todos
          tower.adjustReadableDate $result
          tower.adjustReadableTime $result
          $('.todolist__todos:last').append $todos
        else
          tower.adjustTodo $result
          tower.adjustReadableDate $result
          tower.adjustReadableTime $result
          $('.projects-holder').append $result
